import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';

import colors from './colors';
import styles from './Header.module.scss';

import logo from '../images/header-logo.png';

const NavButton = ({color, to, children}) => (
  <Link className={styles.button} style={{background: colors[color]}} to={to}>
    {children}
  </Link>
);

NavButton.propTypes = {
  color: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.node,
};

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      solid: props.solid,
    };
  }

  componentDidMount() {
    if (!this.props.solid) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (!this.props.solid) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    const top = window.pageYOffset || document.documentElement.scrollTop;
    if (top >= 400) {
      this.setState({solid: true});
    } else {
      this.setState({solid: false});
    }
  }

  render() {
    const maybeMargin = this.props.marginRight ? ` ${styles.marginRight}` : '';
    const maybeSolid = this.state.solid ? ` ${styles.solid}` : '';
    return (
      <header className={styles.container + maybeMargin + maybeSolid}>
        <div className={styles.gradient} />

        <div className="wrap">
          <h1>
            <Link to="/">
              <img alt="Sâmia Bomfim" className={styles.logo} src={logo} />
            </Link>
          </h1>
        </div>

        <nav className={styles.nav}>
          <ul className={styles.navList}>
            <li><NavButton color="yellow" to="/biografia/">Conheça</NavButton></li>
            <li><NavButton color="red" to="/forabolsonaro/">Participe</NavButton></li>
            <li><NavButton color="purple" to="/mandato/">Acompanhe</NavButton></li>
          </ul>
        </nav>
      </header>
    );
  }
}

Header.defaultProps = {
  marginRight: false,
  solid: false,
};

Header.propTypes = {
  marginRight: PropTypes.bool,
  solid: PropTypes.bool,
};

export default Header;
